import { createAsyncThunk } from '@reduxjs/toolkit'
import getStateRules from '../../api/getStateRules'
import { HEALTH_INFORMATION_SEGMENTS } from '../../constant/HEALTH_INFORMATION_SEGMENTS'
import { optionalField, requiredField } from '../common/FORM_SEGMENTS'
import REQUEST_STATUS from '../common/REQUEST_STATUS'
import { asyncPendingReducer } from '../common/defaultReducers'
import { DATE_MASK_OPTIONS } from '../../constant/masks'

const disabledSegment = (segment) => {
  segment.enabled = false
  return segment
}

const mapEeField = (requiresEmployee, isPregnancyQuestion, isFemale) => {
  const shouldRequireField = isPregnancyQuestion ? isFemale && requiresEmployee : requiresEmployee
  return shouldRequireField ? requiredField : {}
}

const mapHealthQuestionsArrayToObject = (healthQuestions, state, segment, requiresEmployee) => {
  let segmentForHealthQuestions = {
    ...state.segments[segment],
    enabled: segment === 'lifeDisability' ?
      state.options.life.value || state.options.disability.value :
      state.options[segment].value,
    underwriting: {
      company: healthQuestions.underwriting.company,
      location: healthQuestions.underwriting.location,
    }
  }

  const applicantSelectedFemale = state.segments.employee.fields.personal.gender.value === 'female'
  Array.of('healthQuestions', 'healthInsuranceQuestions').forEach(healthInfo => {
    segmentForHealthQuestions.fields[healthInfo] = healthQuestions[healthInfo] ? healthQuestions[healthInfo].reduce((obj, item) => {
      const { id, ...itemMinusId } = item
      return {
        ...obj,
        [item.id]: {
          ...itemMinusId,
          medications: [],
          medicalConditions: [],
          ...(item.category === 'OB_GYN' && {
            deliveryDate: { ...optionalField, maskOptions: DATE_MASK_OPTIONS },
            hide: !applicantSelectedFemale
          }),
          ...(item.choices ?
              {
                choices: item?.choices?.reduce((obj, subItem) => {
                  return {
                    ...obj,
                    [subItem.id]: {
                      label: subItem.value,
                      category: subItem.category,
                      id: subItem.id,
                      employee: optionalField,
                      spouse: optionalField,
                      children: optionalField
                    }
                  }
                }, {})
              } : {
                employee: mapEeField(requiresEmployee, item.category === 'OB_GYN', applicantSelectedFemale),
                spouse: {},
                children: {}
              }
          )
        }
      }
    }, {}) : {}
  })

  return segmentForHealthQuestions
}

export const fetchEoiRules = createAsyncThunk(
  'eoi-rules/fetch',
  async ({ state, groupNumber, selectedCoverages }) => {
    return await getStateRules(state, groupNumber, selectedCoverages)
  }
)

export const fetchEoiRulesReducer = {
  [fetchEoiRules.pending]: (state) => asyncPendingReducer(state),
  [fetchEoiRules.fulfilled]: (state, action) => {
    state.context.appDataRequestStatus = REQUEST_STATUS.SUCCEEDED
    HEALTH_INFORMATION_SEGMENTS.forEach(healthQuestionSection => {
      state.segments[healthQuestionSection] = healthQuestionSection in action.payload.productContent ?
        mapHealthQuestionsArrayToObject(
          action.payload.productContent[healthQuestionSection],
          state,
          healthQuestionSection,
          state.options.applicantType.value !== 'SP_ONLY'
        ) : disabledSegment(state.segments[healthQuestionSection])
      state.segments[healthQuestionSection].childrenIncluded = action.payload.childrenIncluded
    })
    state.context.childrenIncluded = action.payload.childrenIncluded
  },
  [fetchEoiRules.rejected]: (state, action) => {
    state.context.appDataRequestStatus = REQUEST_STATUS.FAILED
    state.error = 'A system error has occurred. Please try again later.'
  }
}